import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import './plugins';
import { IO, Api } from './utilities';
import Stash from './stash';

import App from './components/App';
import OrderSummary from './components/screens/OrderSummary';
import OrderDetail from './components/screens/OrderDetail';
import ItemGroups from './components/screens/ItemGroups';
import ItemGroup from './components/screens/ItemGroup';
import ProductSummary from './components/screens/Products';

require('./assets/sass/app.scss');

// Global/library configuration
// -----------------------------------------------------------------------------
Vue.use(VueRouter);

// Routing
// -----------------------------------------------------------------------------
const router = new VueRouter();

router.map({
  '/': { component: OrderSummary, tab: 'current' },
  '/orders': { component: OrderSummary, tab: 'current' },
  '/orders/completed': { component: OrderSummary, tab: 'completed' },
  '/orders/future': { component: OrderSummary, tab: 'future' },
  '/orders/:id': { component: OrderDetail },
  '/item-groups': { component: ItemGroups },
  '/item-groups/:id': { component: ItemGroup },
  '/products': { component: ProductSummary },
});

// Inject git hash into body
// -----------------------------------------------------------------------------
const $version = document.createElement('code');

$version.id = 'app-version';
$version.textContent = process.env.VERSION || 'DEV';

document.querySelector('body').appendChild($version);

// Offline mode notification
// -----------------------------------------------------------------------------
IO.socket.on('connect', () => $version.classList.remove('offline'));
IO.socket.on('error', () => $version.classList.add('offline'));
IO.socket.on('reconnect_error', () => $version.classList.add('offline'));

// Auth check
// -----------------------------------------------------------------------------
window.onload = () =>
  axios
    .get(process.env.AUTH_URL, {
      headers: { Accept: 'application/json' },
      responseType: 'json',
      withCredentials: true,
    })
    .then(({ data }) => {
      Stash.setFulfiller(data);

      Api.get('orders', {
        channel: 'foreground',
        params: { include: 'items,cardAuthorization' },
      }).then(res => Stash.setOrders(res.data.data));

      router.start(App, '#app');
    })
    .catch(error => {
      if (error.response && [401, 403].includes(error.response.status)) {
        window.location.replace(process.env.REAUTH_URL);
      } else {
        throw error; // rethrow if something else went wrong
      }
    });



// WEBPACK FOOTER //
// ./src/main.js